export type DeploymentEnv = 'development' | 'test' | 'production';

export function getDeploymentEnvironment(): DeploymentEnv {
  const mode =
    (import.meta as any)?.env?.MODE ?? process.env.NODE_ENV ?? 'development';
  if (mode === 'production') return 'production';
  if (mode === 'test') return 'test';
  return 'development';
}

export function isProduction(): boolean {
  return (import.meta as any)?.env?.VITE_DEPLOYMENT_ENV === 'production';
}

export function getAppTitle(): string {
  const deploymentEnv = (import.meta as any)?.env?.VITE_DEPLOYMENT_ENV;
  if (deploymentEnv === 'production') return 'Klarvos';
  if (deploymentEnv === 'sandbox') return 'Klarvos Sandbox';

  const mode =
    (import.meta as any)?.env?.MODE ?? process.env.NODE_ENV ?? 'development';
  if (mode === 'production') return 'Klarvos';
  return 'Klarvos Dev';
}

export function getBaseApiUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl) return envUrl as string;

  const origin = globalThis.window?.location?.origin ?? 'http://localhost';
  return `${origin}/api/v1`;
}

/**
 * Base URL for long-lived streaming requests (e.g. chat/o3).
 * When set (e.g. https://api.sandbox.klarvos.com/api/v1), requests use the direct API
 * and bypass CloudFront, avoiding its ~120s origin timeout.
 * When unset, same as getBaseApiUrl() (relative path in dev).
 */
export function getStreamApiUrl(): string {
  const streamUrl = import.meta.env.VITE_STREAM_API_URL;
  if (streamUrl && typeof streamUrl === 'string') return streamUrl as string;
  return getBaseApiUrl();
}

export const environment = {
  mode: getDeploymentEnvironment(),
  apiBaseUrl: getBaseApiUrl(),
  streamApiUrl: getStreamApiUrl(),
};
